module.exports = __webpack_public_path__ + "static/media/club-os-logo-one-color-white.e0a7b851.svg";